import React, { useState } from 'react';
import './App.scss';
import { Route, Routes } from 'react-router-dom';

import Header from './components/Header/Header';
import MainScreen from './pages/MainScreen/MainScreen';
// import AboutMe from './pages/AboutMe/';
import PortfolioPage from './pages/PortfolioPage/PortfolioPage';
import Resume from './pages/Resume/Resume';
import Contact from './pages/Contact/Contact';

import { MdClose, MdMenu } from 'react-icons/md';

function App() {
  const [open, setOpen] = useState(false);

  const handleOpenMenu = () => {
    setOpen(!open)
  }

  return (
    <div className="app dark-theme">

        <div onClick={handleOpenMenu} className="burger">
					{ open ? <MdClose className="burger__icon" /> : <MdMenu className="burger__icon" /> }
				</div>

        { <Header open={open} setOpen={setOpen} /> }  

        <div className="main">
          <div className="wrapper box">
          <Routes>
            <Route path="/" element={<MainScreen />} />
            {/* <Route path="/about" component={AboutMe} /> */}
            <Route path="/resume" element={<Resume />} />
            <Route path="/projects" element={<PortfolioPage />} />
            <Route path="/contact" element={<Contact />} />

            <Route path="*" element={<MainScreen />} />
          </Routes>
          </div>
        </div>

    </div>
  );
}

export default App;
